<template>
    <v-container>

        <v-layout wrap>
            <v-flex xs12>
                <w-main-title
                    :title=" '¡Hola ' + ((currentUser && currentUser.first_name) || '') + '!' "
                    :breadcrumbs="breadcrumbs"
                />
            </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-flex xs12 v-if="isOwner && noBillingData">
                <v-alert :value="true" style="border-radius: 12px" class="mb-3 py-2">
                    <v-icon dark small>mdi-alert-circle-outline</v-icon>
                    ¡Aún no configuras tus datos de facturación!
                    <v-chip small v-ripple color="white" @click="goToConfigureBilling">
                        Configurar
                    </v-chip>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <component :is="dashboardComponentName"/>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
import WMainTitle from '@/components/common/WMainTitle'
import ProviderOnBoarding from '@/components/dashboard/ProviderOnBoarding'
import BasicProviderDashboard from '@/components/dashboard/BasicProviderDashboard'
import SpecialistDashboard from '@/components/dashboard/SpecialistDashboard'
import AdministrativeDashboard from '@/components/dashboard/AdministrativeDashboard'

import {dashboardComponentName} from '@/utils/Account'
import {mapGetters, mapState} from 'vuex'
import PositiveBanner from "@/components/dashboard/PositiveBanner";

export default {
    components: {
        PositiveBanner,
        WMainTitle,
        ProviderOnBoarding,
        BasicProviderDashboard,
        SpecialistDashboard,
        AdministrativeDashboard
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: true,
                    to: ''
                }
            ],
        }
    },
    computed: {
        ...mapState(['currentUser', 'currentProvider',]),
        ...mapGetters(['noBillingData', 'isOwner']),
        dashboardComponentName
    },
    methods: {
        goToConfigureBilling() {
            const vm = this
            vm.$router.push({name: 'panel.provider.settings', query: {view: 'SubscriptionSettings'}})
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}

>>> .v-parallax__content {
    background-color: rgba(82, 82, 82, 0.89) !important
}
</style>
